<script setup lang="ts">
import type { LoginParams, LoginTabType } from '@xianlaibang/shared/types'

// 定义组件emits事件
const emit = defineEmits<{
  toggle: [tab: LoginTabType]
}>();

const userStore = useUserStore();

// 登录表单数据
const loginForm = reactive<LoginParams>({
  userName: '',
  password: ''
    // userName: '19054122739',
  // password: 'lyj522349138'
});

// 表单状态
const checked = ref(false);
// const checked = ref(true);

const isLoading = ref(false);

/**
 * 表单验证
 * @returns 验证结果
 */
function validateForm(): boolean {
  if (!loginForm.userName) {
    ElMessage.error('请输入手机号')
    return false
  }
  if (!loginForm.password) {
    ElMessage.error('请输入密码')
    return false
  }
  if (!checked.value) {
    ElMessage.error('请先同意协议')
    return false
  }
  return true;
}

/**
 * 处理登录操作
 */
async function handleLogin() {
  if (isLoading.value || !validateForm()) return;

  isLoading.value = true

  try {
    const result = await userStore.login(loginForm);
    if (result) {
      await navigateTo('/user');
    }
  } catch (error) {
    console.error('登录失败:', error);
  } finally {
    isLoading.value = false;
  }
}

/**
 * 切换登录选项卡
 */
function handleToggle(tab: LoginTabType) {
  emit('toggle', tab);
}

</script>
<template>
  <div class="form-container">
    <div class="form">
      <div style="padding:60px 80px;">
        <div class="title">
          <span class="active">密码登录</span>
          <span @click="handleToggle('VerifyLogin')">验证码登录</span>
        </div>
        <div>
          <div class="input">
            <ElInput
              v-model="loginForm.userName"
              size="large"
              placeholder="请输入手机号码"
              :prefix-icon="ElIconUser"
            />
          </div>
          <div class="input">
            <ElInput 
              v-model="loginForm.password"
              size="large"
              type="password"
              placeholder="请输入密码"
              show-password
              :prefix-icon="ElIconLock"
            />
          </div>
          <div class="tips">
            <div>
              如未设置密码，请点击<ElButton link @click="handleToggle('SetPwd')">设置密码</ElButton>
            </div>
            <div>
              <ElButton link @click="handleToggle('ResetPwd')">忘记密码?</ElButton>
            </div>
          </div>
          <div class="input">
            <ElButton
              type="primary"
              size="large"
              style="width:100%;"
              :loading="isLoading"
              @click="handleLogin"
            >
              {{ isLoading ? '登录中...' : '登录' }}
            </ElButton>
          </div>
          <div class="input agree">
            <ElCheckbox v-model="checked">已阅读并同意 <NuxtLink to="/notice/2">《用户协议》</NuxtLink> 和<NuxtLink to="/notice/3">《隐私政策》</NuxtLink></ElCheckbox>
          </div>
          <div class="input other" @click="handleToggle('WechatLogin')">
            <span>第三方账号登录</span>
            <img :src="useOssImage('/img/wechat.png')" alt="logo">
          </div>
        </div>
      </div>
    </div>
    <div class="picture">
      <div class="content">
        <div class="title">Hello!欢迎登录来到闲来帮</div>
        <hr class="hr">
        <div class="subtitle">如果您还未有账号，请点击下方按钮注册</div>
        <div class="button">
          <ElButton
            type="primary"
            @click="handleToggle('RegisterAccount')"
            size="large"
            round
            class="reg-btn"
          >
            去注册
          </ElButton>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.title {

  span:nth-child(1) {
    color: #0E2036;
  }

  span:nth-last-child(1) {
    border-left: 2px solid #999;
  }
}

.tips {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 20px;
}
</style>
